module.exports = __webpack_public_path__ + "media/images/city/041-vincent-thomas-bridge-5c737d48eb274b3390cd7c561944f76a.svg";